import axios from 'axios'
import config from '../../config'
import snackbar from '../mixins/snackbar'

var axiosInstance = axios.create(config.axiosConfig)
axiosInstance.interceptors.response.use(function (response) {
    var data = response.data
    setTimeout(() => {
        snackbar.methods.snackbarAuto(data)
    }, 0)
    return response
}, function (error) {
    if (error.response.status >= 500 && error.response.status < 600) {
        snackbar.methods.snackbarError("ERROR COMMUNICATING WITH SERVER. PLEASE REFRESH. IF ERROR STILL PERSISTS CONTACT ADMIN.")
    }
    // snackbar.methods.snackbarAuto(error.response.data)
    return error
})

export default axiosInstance